import styled from "styled-components";

export const StyledSpan = styled.div<{ color?: string }>`
  svg path {
    fill: ${({ color }) => (color ? `${color} !important` : `none`)};
  }
`;

export const MagnifyingGlassIcon = () => (
  <svg width="65" height="64" viewBox="0 0 65 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M42.5479 37.4082C41.9494 38.9702 39.3903 41.4628 38.0273 42.0278"
      stroke="black"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M36.0508 35.375L40.1638 39.2158"
      stroke="black"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M37.0117 34.8926L41.1247 38.7333"
      stroke="black"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M35.46 36.1162L39.3975 40.2502"
      stroke="black"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="23.625"
      cy="22.75"
      r="17.5"
      stroke="black"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <ellipse
      cx="23.9375"
      cy="23"
      rx="17.8125"
      ry="17.75"
      stroke="black"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="23.625"
      cy="22.75"
      r="13.75"
      stroke="black"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <ellipse
      cx="23.3125"
      cy="23.1875"
      rx="13.4375"
      ry="13.3125"
      stroke="black"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.552 29.5722C13.0163 26.8983 12.6078 22.9102 14.1732 19.4394"
      stroke="black"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.6924 16.8092C16.0288 16.3603 16.2312 16.0989 16.7488 15.7051"
      stroke="black"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M38.3683 42.8844C37.822 42.3158 37.5301 41.5312 37.9295 40.8513C38.5568 39.7836 39.8033 38.4814 41.0081 37.6305C41.8731 37.0197 42.9918 37.265 43.7788 37.9734L59.0015 51.6748C59.2153 51.8672 59.4274 52.0873 59.4559 52.3735C59.625 54.0718 56.2416 57.4697 54.1701 58.2291C53.5874 58.4427 53.0076 58.1235 52.5776 57.6759L38.3683 42.8844Z"
      stroke="black"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
